import { Section } from '../../lib/interfaces/ApiControl';
import { AutomatedOverviewBlock, Task } from '../../lib/interfaces/Task';
import { FIELD_TYPES } from '../Form/form.utils';

const generateItemIdFromLabel = (
	label: string,
	store: Record<string, number>,
) => {
	let id = label
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');

	if (store[id]) {
		id = `${id}-${Math.floor(1000 + Math.random() * 9000)}`;
	}
	store[id] = 1;
	return id;
};

export const preformatTaskContent = (
	task: Task,
	currentLanguage: string,
): Task => {
	const store = {};
	if (!task.hasAutomatedOverviewBlock) {
		const automatedOverviewBlock: AutomatedOverviewBlock[] = [];
		const content = task?.content[currentLanguage];
		if (content) {
			content.forEach((item) => {
				let automatedTitle = '';
				let isFullApiControl = false;
				if (item.type === FIELD_TYPES.API_CONTROL) {
					isFullApiControl = item?.options?.apiControlSelections?.level === 'full';
				}
				if (
					item.name !== `name_${currentLanguage}` &&
					item.name !== `content_${currentLanguage}` &&
					item.type !== FIELD_TYPES.FILE &&
					item.type !== FIELD_TYPES.CODE_BLOCK &&
					item.type !== FIELD_TYPES.OVERVIEW_BLOCK &&
					item.type !== FIELD_TYPES.SECRET_CONTENT
					// !isFullApiControl
				) {
					if (item.type === FIELD_TYPES.CODE_EDITOR) {
						if (item.options?.title) {
							automatedTitle = item.options.title;
						}
					} else if (item.type === FIELD_TYPES.SAND_PACK_WITH_TEXT) {
						if (item.options?.heading) {
							automatedTitle = item.options.heading;
						}
					} else if (item.reference) {
						const apis = item.reference?.content?.[currentLanguage]?.find(
							(field) => field.type === 'apiControlBlock',
						);
						if (apis) {
							if (isFullApiControl) {
								if (apis) {
									const sections = apis.options?.sections;
									if (sections && sections.length) {
										sections.forEach((section: Section) => {
											automatedOverviewBlock.push({
												title: section.title,
												id: section.id,
												type: item.type,
											});
										});
									}
								}
							}
						} else {
							const title = item.reference?.content?.[currentLanguage]?.[0]?.content;
							if (title) {
								automatedTitle = title;
							}
						}
					} else if (item?.options?.label || item?.options?.label === '') {
						if (item?.options?.label) {
							automatedTitle = item.options.label;
						}
					} else if (
						item.label &&
						typeof item.content === 'string' &&
						item.content
					) {
						automatedTitle = item.content;
					}
				} else if (item.type === FIELD_TYPES.OVERVIEW_BLOCK) {
					task.isAutomatedOverviewDisabled = true;
				}
				if (automatedTitle) {
					item.id = generateItemIdFromLabel(automatedTitle, store);
					automatedOverviewBlock.push({
						title: automatedTitle,
						id: item.id,
						type: item.type,
					});
				}
			});
			content.splice(1, 0, {
				type: FIELD_TYPES.AUTOMATED_OVERVIEW,
				name: `automatedOverview_${currentLanguage}`,
				label: '',
				content: '',
				options: { items: automatedOverviewBlock },
			});
		}

		task.hasAutomatedOverviewBlock = true;
	}
	return task;
};
